export enum ValidationType
{
    Subject = 1
}